import { BFScreen } from "@/components/standard/screen/BFScreen"
import { SoftCreditPullScreen } from "@/screens/loans/SoftCreditPullScreen"
import { View } from "react-native"
import { H2 } from "@/components/standard/BFText"
import { router, useLocalSearchParams } from "expo-router"

export default function PublicSoftCreditPullScreen() {
  const { loanId } = useLocalSearchParams()

  return (
    <BFScreen
      headerSticky={false}
      dark={false}
      className={"p-5"}
      header={
        <View className={"pt-5 pb-2"}>
          <H2>Soft Credit Pull</H2>
        </View>
      }
    >
      <SoftCreditPullScreen
        defaults={{
          loanId: loanId as string,
        }}
        onSubmit={() => {
          router.replace("/softcreditpull/confirmation")
        }}
      />
    </BFScreen>
  )
}
